// Import the table float script for this app to use
// eslint-disable-next-line no-unused-vars
import TableFloat from '_shared_/utils/table-float';

export default {
	bind(el) {
		el.classList.add('mk-tablefloat');
	},
	inserted(el) {
		// Bind the float functionality
		$(() => {
			$(el).mktablefloat();
		});
	}
};



// WEBPACK FOOTER //
// ./src/shared/directives/TableFloat.js